import { redirect } from "@tanstack/react-router";

import { store } from "@/app/store";

export const validateLogin = () => {
  const { auth } = store.getState();

  if (!auth.auth.email) {
    throw redirect({ to: "/login" });
  }
};
